import script from "./FormElement.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElement.vue?vue&type=script&setup=true&lang=js"

import "./FormElement.vue?vue&type=style&index=0&id=30f62218&lang=scss"

const __exports__ = script;

export default __exports__